import { User } from '../User';

export interface Requisition {
  id: number;
  status: RequisitionStatus;
  approver_ids: number[];
  ownerUserId: number;
  uid: string;
  ownerUser: User;
  reminderSentAt?: Date;
  approvers?: RequisitionApprover[];
}

export interface RequisitionApprover {
  id: number;
  user: User;
  order: number;
  answer?: RequisitionApproverAnswer;
  declineReason?: string;
}

export enum RequisitionStatus {
  Approved = 'approved',
  Archived = 'archived',
  Completed = 'completed',
  Declined = 'declined',
  Pending = 'pending',
}

export enum RequisitionApproverAnswer {
  Approved = 'approved',
  Declined = 'declined',
}
